import { gql } from '@apollo/client';

export const GET_PLAN_CHARACTERISTICS = gql`
  query getPlanCharacteristics($refetchData: Boolean) {
    getPlanCharacteristics(refetchData: $refetchData) {
      id
      name
      productFamily
      isUnlimited
      isBuyMoreAvailable
      uploadSpeed
      positioning
      dataAllowanceText
      inflectionPointText
      dataCap
      usageMeter
      benefits
      titleAddOns
      inflectionPoint
      uploadSpeedText
      freeZoneTime
      dataCapUnits
      hasUnlimitedUsageMeter
      isUnleashed
      isUnleashedMaxPlan
      attributes
      downloadSpeed
      downloadUnits
      fiberSpeedText
    }
  }
`;

export const GET_PLAN_PRICE = gql`
  query getCurrentPlanPrice {
    getCurrentPlanPrice {
      price
    }
  }
`;

export const GET_USAGE_TIER = gql`
  query getUsageTier($planName: String) {
    getUsageTier(planName: $planName) {
      tier
    }
  }
`;

export const GET_CURRENT_USAGE = gql`
  query getCurrentUsage($refetchData: Boolean) {
    getCurrentUsage(refetchData: $refetchData) {
      monthlyDataUsed
      buyMoreDataUsed
      displayedTotalDataUsed
      monthlyDataCap
      buyMoreDataCap
      displayedTotalDataCap
      monthlyDataUsedRatio
      buyMoreDataUsedRatio
      monthlyDataRemaining
      buyMoreDataRemaining
      freeZoneDataUsed
      standardDataUsed
      hasBreachedDataAllowance
      endDate
      startDate
      daysLeft
    }
  }
`;
